import ProgressBar from 'react-bootstrap/ProgressBar';

const Progress = ({value}) => {
    if (value < 100 && value > 0) {
        return (
            <ProgressBar animated now={value} label={`${value}%`}/>
        )
    }
    return null;
}

export default Progress;